import { PropsWithChildren } from 'react'

import { createStyles } from 'antd-style'

import { Breadcrumb } from '@eastcoal/router/components/Breadcrumb'

import { PageContainerProps } from './interface'

const useStyles = createStyles(
  (
    { token },
    { fullness, transparent, padding, strimTopPadding }: PageContainerProps
  ) => {
    const paddingValue = padding ?? token.paddingMD
    return {
      container: {
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        overflow: fullness ? 'hidden' : undefined
      },
      breadcrumb: {
        flex: 'none'
      },
      main: {
        flex: 1,
        paddingInline: paddingValue,
        paddingBlockEnd: paddingValue,
        paddingBlockStart: strimTopPadding ? undefined : paddingValue,
        backgroundColor: transparent ? undefined : token.colorWhite,
        borderRadius: token.borderRadius
      }
    }
  }
)

export const PageContainer = ({
  className,
  style,
  classNames,
  styles: extrernalStyles,
  fullness = false,
  padding,
  transparent = false,
  strimTopPadding = false,
  breadcrumb = true,
  children
}: PropsWithChildren<PageContainerProps>) => {
  const { cx, styles } = useStyles({
    breadcrumb,
    transparent,
    fullness,
    padding,
    strimTopPadding
  })

  return (
    <div
      className={cx('page-container', styles.container, className)}
      style={style}
    >
      {breadcrumb && (
        <Breadcrumb
          className={cx(styles.breadcrumb, 'page-container-breadcrumb')}
        />
      )}
      <div
        className={cx(styles.main, classNames?.body)}
        style={extrernalStyles?.body}
      >
        {children}
      </div>
    </div>
  )
}
